"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationTypes = exports.ReviewObjectTypes = void 0;
var reviewsApiTypes_1 = require("../__generated__/reviews/reviewsApiTypes");
Object.defineProperty(exports, "ReviewObjectTypes", { enumerable: true, get: function () { return reviewsApiTypes_1.SravniOrganizationsSharedReviewObjectType; } });
Object.defineProperty(exports, "OrganizationTypes", { enumerable: true, get: function () { return reviewsApiTypes_1.SravniOrganizationsSharedOrganizationType; } });
